
























































import ArticleInfoBaseTemplate from './ArticleInfoBaseTemplate';

export default ArticleInfoBaseTemplate.extend({
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html
        ? this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '')
        : this.$props.article.content.title.text;
    },
  },
});
